import * as React from 'react';
import makeStyles from "@mui/styles/makeStyles";
import ButtonGroup from "@mui/material/ButtonGroup";
import Button from "@mui/material/Button";
import Hl7utils from "./hl7utils";
import {TextField} from "@mui/material";
import {useEffect} from "react";
import {useDispatch} from "react-redux";
import AgyleDialog from "../../../components/modal/agyleDialog";
import {setSnackbar} from "../../../store/reducers/globals";
import {setLoading} from "../../../store/reducers/patient";
import useOpenState from "../../../hooks/useOpenState";
import API from "../../../app/api";
import Hl7ViewJson from "./hl7_view_json";
import Grid from "@mui/material/Grid";

const useStyles = makeStyles((theme) => ({
    hl7Res: {
        width: 1000,
        overflow: "auto"
    },
    response: {
        marginTop: 20
    },
    agyleButton: {
        backgroundColor: "#448FFF"
    },
    whiteButton: {
        backgroundColor: "#FFFFFF",
        color: "#448FFF",
        borderColor: "transparent",
        boxShadow: "0 0 5px grey",
        "&:hover": {
            borderColor: "transparent"
        }
    }
}));

export const copyToClipboard = (text) => {
    if (!navigator.clipboard) {
        return;
    }
    navigator.clipboard.writeText(text)
        .then(() => {
            console.log("Clipboard filled message");
        }).catch(err => console.error("Error: ", err));
};

function Hl7Console(props) {
    const classes = useStyles();

    const [message, setMessage] = React.useState("");
    const controller = new AbortController();

    const [hl7JsonMessage, setHl7JsonMessage] = React.useState("");
    const [isModalOpen, openModal, closeModal] = useOpenState(false, true);

    const [hl7Response, setHL7Response] = React.useState("");

    const dispatch = useDispatch();

    const sendHL7Message = () => {
        dispatch(setLoading(true));
        API.sendMessageHL7(message, controller.signal).then(response => {
                if(response && response.error) {
                    dispatch(setSnackbar({type: "error", message: response.error}));
                }
                if(response && response.response) {
                    setHL7Response(response.response);
                }
            })
            .catch(err => {
                console.error(err);

            })
            .finally(() => {
                dispatch(setLoading(false));
            });
    }
    const formatMessage = () => {
        let pm = Hl7utils.parseMessages(message);
        if (pm && pm.length > 0) {
            setMessage(pm[0]);
            copyToClipboard(pm[0]);
        }
    }




    const showJson = () => {
        let hl7obj1 =  Hl7utils.parseHl7ToJson(message);
        let hl7obj2 = {};
        for (let o1 of hl7obj1) {
            let segment = o1[0];
            hl7obj2[segment] = {};
            for (let i = 1; i < o1.length; i++) {
                hl7obj2[segment][`${segment}.${i}`] = o1[i];
            }
        }
        setHl7JsonMessage(JSON.stringify(hl7obj2, null, 2))

        openModal()
    }

    useEffect(()=>{
        return () => {
            controller.abort();
        };
    }, [])


    const handleCloseModal = (_e, reason) => {
        closeModal(_e, reason);
    };

    return (
        <div>
            <AgyleDialog
                title={"Hl7 Message as JSON"}
                open={isModalOpen}
                onClose={handleCloseModal}
                width={"lg"}
                fullWidth
                onSave={handleCloseModal}
            >
                <pre> {hl7JsonMessage} </pre>
            </AgyleDialog>
            <TextField
                name={"value"}
                label={"Message"}
                className={classes.input}
                onChange={(e)=> {setMessage(e.target.value)}}
                value={message}
                style={{width: "100%"}}
                inputProps={{
                    style: {
                        height: "400px",
                    },
                }}
                maxRows={15}
                variant="outlined"
                multiline
                InputLabelProps={{
                    shrink: true,
                    // display: 'none'
                }}
            />

            <Grid container spacing={2} xs={6} sx={{mt: 2}}>
                <Grid item xs={4}>
                    <Button
                        className={classes.agyleButton}
                        size={'normal'}
                        color='primary'
                        variant='contained'
                        onClick={sendHL7Message}
                    >
                        {'Send'}
                    </Button>
                </Grid>
                <Grid item xs={8}>
                    <Button
                        className={classes.whiteButton}
                        sx={{mr: 4}}
                        size={'normal'}
                        variant='outlined'
                        onClick={formatMessage}
                    >
                        {'Format'}
                    </Button>
                    <Button
                        size={'normal'}
                        className={classes.whiteButton}
                        variant='outlined'
                        onClick={openModal}
                    >
                        {'Show JSON'}
                    </Button>
                </Grid>
            </Grid>

            <Hl7ViewJson isOpen = {isModalOpen} handleCloseModal = {closeModal} message = {message}/>
            {hl7Response &&
                <div className={classes.response}>
                    <div> Response: </div>
                    <pre className={classes.hl7Res}>{hl7Response}</pre>
                </div>
            }


        </div>
   );
}

export default Hl7Console;
